var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "cruise-info__services",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _setup.detail_click.apply(null, arguments)
            },
          },
        },
        [_vm._v("Подробнее")]
      ),
      _vm._v(" "),
      _c(
        _setup.Modal,
        {
          attrs: {
            title: "",
            "wrapper-class": "animate__animated",
            "modal-class": "fill-modal",
            "in-class": "animate__zoomIn hideScroll",
            "out-class": "animate__zoomOut hideScroll",
          },
          model: {
            value: _setup.isModalShown,
            callback: function ($$v) {
              _setup.isModalShown = $$v
            },
            expression: "isModalShown",
          },
        },
        [
          _c(
            "div",
            { staticClass: "fill-modal__header fill-modal-header" },
            [
              _c(
                _setup.ModalTitle,
                {
                  staticClass: "fill-modal-header__title",
                  on: {
                    close: function ($event) {
                      _setup.isModalShown = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_setup.props.excursion.name) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fill-modal__content" },
            [
              _c(_setup.ExcursionInner, {
                attrs: { excursion: _setup.props.excursion },
              }),
              _vm._v(" "),
              _c(_setup.InsertHtml, {
                attrs: {
                  html: _setup.props.excursion.description,
                  link: "pdf",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }